<template>
    <div
        v-if="!onboardingUser.disableInvite"
        class="rounded p-3 bg-white text-left"
    >
        <h5 class="mb-0">
            <font-awesome-icon
                icon="fa-duotone fa-link"
                class="branded"
                size="lg"
            />
            {{ $t("Invite to Earn") }}
        </h5>

        <div class="mt-2 small text-secondary">
            {{ $t("Share your invite link to earn from every customer and creator who joins through it") }}
            <font-awesome-icon icon="fa-light fa-arrow-down" />
        </div>

        <div v-if="creatorUser" class="mt-2">
            <b-input-group>
                <b-form-input :value="creatorUser.inviteUrlVanity" readonly />
                <b-input-group-append>
                    <b-btn @click="copyUrl" variant="primary">
                        {{ $t("Copy") }}
                    </b-btn>
                </b-input-group-append>
            </b-input-group>

            <b-alert
                v-if="hasCopied"
                variant="success"
                show
                dismissible
                @dismissed="$store.commit('creatorInvite/setHasCopied', false)"
                class="small mt-2 mb-0"
            >
                <h5>
                    <font-awesome-icon icon="fa-light fa-check" />
                    {{ $t("Copied") }}
                </h5>
                {{
                    $t(
                        "Link copied. Send it to customers or creators through WhatsApp, Telegram, or any messaging app. They need to open your link before signing up for you to get credit."
                    )
                }}
            </b-alert>
        </div>

        <b-row class="mt-3" no-gutters>
            <b-col>
                <creator-invite-email />
            </b-col>
            <b-col class="px-1">
                <creator-invite-qrcode />
            </b-col>
            <b-col>
                <b-button
                    @click="showGuide"
                    variant="light"
                    class="text-truncate"
                    block
                    size="sm"
                    pill
                >
                    <font-awesome-icon icon="fa-duotone fa-info-circle" />
                    {{ $t("Help") }}
                </b-button>
            </b-col>
        </b-row>

        <creator-invite-guide-modal />
    </div>
</template>

<script>
import { mapState } from "vuex";

import CreatorInviteGuideModal from "@/components/creator/invite/CreatorInviteGuideModal";
import CreatorInviteEmail from "@/components/creator/invite/CreatorInviteEmail";
import CreatorInviteQrcode from "@/components/creator/invite/CreatorInviteQrcode";

import copy from "clipboard-copy";

export default {
    created() {
        this.$store.dispatch("creatorDashboard/refresh");
    },
    computed: {
        ...mapState("creatorDashboard", ["creatorUser"]),
        ...mapState("creatorInvite", ["inviteUrl", "hasCopied"]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    methods: {
        copyUrl() {
            copy(this.creatorUser.inviteUrl);
            this.$store.commit("creatorInvite/setHasCopied", true);
        },
        showGuide() {
            this.$store.commit(
                "interface/setInfluencerGuideModalVisible",
                true
            );
        },
    },
    components: {
        CreatorInviteGuideModal,
        CreatorInviteQrcode,
        CreatorInviteEmail,
    },
};
</script>
